<template>
  <div class="edu-wrap">
    <Header />
    <div class="edu-wrap__banner">
      <img src="../../assets/banner-edu.jpg" />
    </div>
    <div class="edu-wrap__content">
        <div class="edu-wrap__content-title">
            <h2>2022年4月15日第七个全民国家安全教育日</h2>
        </div>
        <div class="edu-wrap__content-img">
            <img src="../../assets/word1.png" alt="">
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>全民国家安全教育日由来？</h6>
            </div>
            <div class="edu-wrap__content-content_info">
                2015年7月1日，全国人大常委颁布了新版《中华人民共和国国家安全法》，其中第十四条规定，每年4月15日为全民国家安全教育日。2022年4月15日是第七个全民国家安全教育日，活动主题为“树牢总体国家安全观，感悟新时代国家安全成就，为迎接党的二十大胜利召开营造良好氛围”。
            </div>
        </div>
         <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>什么是国家安全？</h6>
            </div>
            <div class="edu-wrap__content-content_info">
                根据《国家安全法》第2条规定，国家安全是指国家政权、主权、统一和领土完整、人民福祉、经济社会可持续发展和国家其他重大利益相对处于没有危险和不受内外威胁的状态，以及保障持续安全状态的能力。
            </div>
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>公民维护国家安全的义务？</h6>
            </div>
            <div class="edu-wrap__content-content_info">
                <p>
                    《中华人民共和国国家安全法》规定了关于社会组织和公民个人在维护国家安全方面的义务，国家安全法第77条明确规定了以下几个方面：
                </p>
                <p>（一）遵守宪法、法律法规关于国家安全的有关规定；</p>
                <p>（二）及时报告危害国家安全活动的线索；</p>
                <p>（三）如实提供所知悉的涉及危害国家安全活动的证据；</p>
                <p>（四）为国家安全工作提供便利条件或者其他协助；</p>
                <p>（五）向国家安全机关、公安机关和有关军事机关提供必要的支持和协助；</p>
                <p>（六）保守所知悉的国家秘密；</p>
                <p>（七）法律、行政法规规定的其他义务。</p>
                <p>此外，该条还明确规定：任何个人和组织不得有危害国家安全的行为，不得向危害国家安全的个人或者组织提供任何资助或者协助。</p>
            </div>
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>十个坚持是什么？</h6>
            </div>
        </div>
        <div class="edu-wrap__content-img">
            <img src="../../assets/word2.png" alt="">
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>总体国家安全观核心要义是什么？</h6>
            </div>
        </div>
        <div class="edu-wrap__content-img">
            <img src="../../assets/word3.png" alt="">
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>五个统筹</h6>
            </div>
        </div>
        <div class="edu-wrap__content-img">
            <img src="../../assets/word4.png" alt="">
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>国家安全包括哪几个方面</h6>
            </div>
        </div>
        <div class="edu-wrap__content-img">
            <img src="../../assets/word5.png" alt="">
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_title">
                <h6>全民国家安全教育日活动标识</h6>
            </div>
        </div>
        <div class="edu-wrap__content-img">
            <img src="../../assets/word6.png" alt="">
        </div>
        <div class="edu-wrap__content-content">
            <div class="edu-wrap__content-content_info">
                <p>标识由数字415、红星和光芒组成。</p>
                <p>数字4的设计，形似宣誓的动作，表现出全国人民誓要维护国家安全的决心，及“安全有我”的个人责任感。同时也有利于提高415的辨识度，便于传播。红星在数字上方闪耀，意指在党的领导下，国家安全得到全面加强，光明前景催人奋进。数字415和红星组成稳定的三角形，光芒闪耀，使整个标志成优美的扇形。数字415意指4月15日全民国家安全教育日，简洁明了。文字“全民国家安全教育”位于标志下方，黑色字体稳重，托举扇形，意指全民国家安全教育坚如磐石。</p>
            </div>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";

export default {
  name: "InvestmentEducationNew",
  data() {
    return {
      
    };
  },
  methods: {
   
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style scoped lang="scss">
.edu-wrap {
  min-height: 100%;
  background: rgba(245, 245, 245, 1);
  padding-top: 6rem;

  &__banner {
    img {
      width: 100%;
      margin-bottom: 0;
    }
  }
  &__content{
    width: 75rem;
    margin: 0 auto;
    padding: 3.13rem 6.26rem;
    padding-bottom: 180px;
    background-color: #fff;
    margin-top: 0.1rem;
    text-align: center;
    color: #323232;
    font-size: 1rem;
    overflow: hidden;
    &-title{
        color: red;
        margin-bottom: 1rem;
    }
    &-img{
        img{width: 100%;}
    }
    &-content{
        text-align: left;
        margin: 15px auto;
        &_title{
            display: flex;
            h6{
                display: inline-block;
                padding: 3px 10px;
                background-color: #DE3636;
                color: #fff;
                text-align: left;
                font-size: 1.2rem;
            }
        }
        &_info{
            padding: 5px 10px;
            text-indent: 2rem;
            background-color: #FFF6F6;
            color: #DE3636;
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investment-edu-new/InvestmentEducationNew.vue